import * as React from 'react';
import * as moment from 'moment';
import { ICalendarAppText } from '../../classes/calendar-text';
import { ICalendarAppState } from '../../../redux-state';
import { Dispatch } from 'redux';
import { goToMonth } from '../../../redux-state/actions/calendar.actions';
import { connect } from 'react-redux';
import MonthNavigationView from '../../../views/custom/month-navigation-view';


interface IMonthNavigationExternalProps {
}

interface StateToProps {
    text: ICalendarAppText;
    currentMonth: moment.Moment;
    validMonths: moment.Moment[];
    filteredMonths : string
}

interface DispatchToProps {
    goToMonth: (date: moment.Moment) => void;
}

export type MonthNavigationProps = IMonthNavigationExternalProps & StateToProps & DispatchToProps;

export class MonthNavigationBase extends React.Component<MonthNavigationProps, any> {
    render() {
        return (
            <MonthNavigationView {...this.props}/>
        )
    }
}

function mapStateToProps(state: ICalendarAppState, ownProps: IMonthNavigationExternalProps): StateToProps {
    const monthsFilter = state.calendar.eventFilter? state.calendar.eventFilter.filter(a => a.key === "month")[0]: undefined
    return {
        text: state.calendarText,
        currentMonth: state.calendar.currentDate,
        validMonths: state.calendarSettings.monthsOnCalendar,
        filteredMonths: monthsFilter ? monthsFilter.selectedValue : ""
    }
}

function mapDispatchToProps(dispatch: Dispatch): DispatchToProps {
    return {
        goToMonth: (date: moment.Moment) => dispatch(goToMonth(date))
    }
}

export default connect<StateToProps, DispatchToProps>(mapStateToProps, mapDispatchToProps)(MonthNavigationBase);